import React, { useCallback, useEffect, useState } from 'react';
import { $getSelection, $isRangeSelection } from 'lexical';
import { $isHeadingNode } from '@lexical/rich-text';
import { BLOCKS } from '../utils/utils';
import { blockTypeToBlockName } from '../constants/constants';
import { $isListNode } from '@lexical/list';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { Select } from 'baseui/select';
import { SELECT_PROPS } from '../../../constants/constants';
import { mergeRegister } from '@lexical/utils';
const BLOCK_FORMAT_OPTIONS = [{
  blockType: 'h1',
  blockName: 'Heading 1'
}, {
  blockType: 'h2',
  blockName: 'Heading 2'
}, {
  blockType: 'h3',
  blockName: 'Heading 3'
}, {
  blockType: 'h4',
  blockName: 'Heading 4'
}, {
  blockType: 'h5',
  blockName: 'Heading 5'
}, {
  blockType: 'h6',
  blockName: 'Heading 6'
}, {
  blockType: 'paragraph',
  blockName: 'Normal'
}, {
  blockType: 'code',
  blockName: 'Code Block'
}, {
  blockType: 'quote',
  blockName: 'Quote'
}, {
  blockType: 'equation',
  blockName: 'Equation'
}];
const BlockFormatDropDown = () => {
  const [editor] = useLexicalComposerContext();
  const [blockType, setBlockType] = useState<keyof typeof blockTypeToBlockName>('paragraph');
  const [isEditable, setIsEditable] = useState(() => editor.isEditable());
  const updateToolbar = useCallback(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
      return;
    }
    const anchorNode = selection.anchor.getNode();
    const element = anchorNode.getKey() === 'root' ? anchorNode : anchorNode.getTopLevelElementOrThrow();
    const elementKey = element.getKey();
    const elementDOM = editor.getElementByKey(elementKey);
    if (elementDOM === null || $isListNode(element)) {
      setBlockType('paragraph');
      return;
    }
    const type = $isHeadingNode(element) ? element.getTag() : element.getType();
    if (type in blockTypeToBlockName) {
      setBlockType((type as keyof typeof blockTypeToBlockName));
    }
  }, [editor]);
  useEffect(() => {
    return mergeRegister(editor.registerEditableListener(editable => {
      setIsEditable(editable);
    }), editor.registerUpdateListener(({
      editorState
    }) => {
      editorState.read(() => {
        updateToolbar();
      });
    }));
  }, [updateToolbar, editor]);
  return <Select disabled={!isEditable} {...SELECT_PROPS} options={BLOCK_FORMAT_OPTIONS} labelKey="blockName" valueKey="blockType" onChange={({
    value
  }) => {
    BLOCKS[(value[0].blockType as keyof typeof blockTypeToBlockName)]({
      editor,
      type: blockType
    });
    setBlockType(value[0].blockType);
  }} value={[{
    blockType,
    blockName: blockTypeToBlockName[blockType]
  }]} />;
};
export default BlockFormatDropDown;